/** Figma "Notifications & Fields"; the icon font has no minus-circle */
export const MinusCircle = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="9" stroke="var(--secondary-colors-red)" strokeWidth="2" />
            <path
                d="M8 12H16"
                stroke="var(--secondary-colors-red)"
                strokeWidth="2"
                strokeLinecap="round"
            />
        </svg>
    );
};
